// extracted by mini-css-extract-plugin
export default {"claimsSubmissionWrapper":"styles_claimsSubmissionWrapper__HTCRm"};